import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/homeData';
import FadeInSection from '@/components/base/FadeInSection';

const articleImageUrls: Record<string, string> = {
  'article-season': 'https://readdy.ai/api/search-image?query=Tropical%20island%20landscape%20showing%20different%20seasons%20blended%20together%2C%20sunny%20blue%20sky%20with%20lush%20green%20palm%20trees%2C%20turquoise%20ocean%20water%2C%20travel%20magazine%20cover%20style%2C%20warm%20and%20inviting%20atmosphere%2C%20professional%20landscape%20photography&width=800&height=500&seq=article-season-2026&orientation=landscape',
  'article-sunset': 'https://readdy.ai/api/search-image?query=Breathtaking%20tropical%20sunset%20over%20calm%20ocean%20with%20vibrant%20orange%20pink%20and%20purple%20sky%2C%20silhouette%20of%20palm%20trees%20and%20rock%20formations%2C%20reflection%20on%20water%20surface%2C%20serene%20and%20romantic%20mood%2C%20fine%20art%20nature%20photography&width=800&height=500&seq=article-sunset-2026&orientation=landscape',
  'article-budget': 'https://readdy.ai/api/search-image?query=Elegant%20travel%20planning%20desk%20with%20world%20map%2C%20passport%2C%20camera%2C%20and%20tropical%20flowers%2C%20warm%20wooden%20surface%2C%20soft%20natural%20light%20from%20window%2C%20lifestyle%20flat%20lay%20photography%20with%20warm%20tones&width=800&height=500&seq=article-budget-2026&orientation=landscape',
  'article-proposal': 'https://readdy.ai/api/search-image?query=Romantic%20beach%20proposal%20moment%20captured%20from%20behind%2C%20man%20on%20one%20knee%20holding%20ring%20box%2C%20woman%20with%20hands%20covering%20face%20in%20surprise%2C%20sunset%20golden%20hour%20light%2C%20flower%20petal%20path%2C%20emotional%20and%20heartwarming%20scene%2C%20cinematic%20photography&width=800&height=500&seq=article-proposal-2026&orientation=landscape',
  'article-food': 'https://readdy.ai/api/search-image?query=Beautifully%20plated%20tropical%20seafood%20dinner%20on%20a%20beachside%20table%20with%20candles%20and%20flowers%2C%20ocean%20view%20in%20background%20at%20sunset%2C%20elegant%20table%20setting%2C%20romantic%20dining%20atmosphere%2C%20food%20and%20travel%20photography%20style&width=800&height=500&seq=article-food-2026&orientation=landscape',
  'article-photo': 'https://readdy.ai/api/search-image?query=Fashionable%20couple%20posing%20on%20tropical%20beach%20in%20flowing%20outfits%2C%20professional%20camera%20equipment%20in%20foreground%2C%20golden%20hour%20backlight%20creating%20dreamy%20silhouette%20effect%2C%20magazine%20editorial%20style%2C%20lifestyle%20fashion%20and%20travel%20photography&width=800&height=500&seq=article-photo-2026&orientation=landscape',
};

export default function FeaturedArticles() {
  return (
    <section className="section-padding bg-background-50">
      <div className="container-wide">
        <FadeInSection>
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              精选攻略文章
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              专业团队实地探访，为你带来最实用的爱情岛旅行攻略
            </p>
          </div>
        </FadeInSection>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article, index) => (
            <FadeInSection key={article.slug} delay={index * 80}>
              <Link
                to={`/article/${article.slug}`}
                className="group bg-background-100 rounded-xl overflow-hidden transition-all duration-200 hover:bg-background-200/70 block"
              >
                <div className="relative h-44 md:h-48 overflow-hidden">
                  <div
                    className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
                    style={{ backgroundImage: `url('${articleImageUrls[article.thumbnailSeq]}')` }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-0.5 bg-secondary-500 text-background-50 text-xs font-medium rounded-full">
                      {article.category}
                    </span>
                  </div>
                </div>

                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mb-3 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-1.5 mb-3 flex-wrap">
                    {article.tags.slice(0, 3).map((tag) => (
                      <span key={tag} className="px-2 py-0.5 bg-primary-50 text-primary-700 text-xs rounded-full whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="flex items-center justify-between pt-3 border-t border-background-200 text-xs text-foreground-500">
                    <div className="flex items-center gap-3">
                      <span>{article.date}</span>
                      <span className="flex items-center gap-1">
                        <span className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-time-line text-[10px]"></i>
                        </span>
                        {article.readTime}
                      </span>
                    </div>
                    <span>{article.author}</span>
                  </div>
                </div>
              </Link>
            </FadeInSection>
          ))}
        </div>
      </div>
    </section>
  );
}